import React, { useState, useEffect } from "react";
import config from "../../../config/config";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft, FaCheck, FaTimes } from "react-icons/fa";
import axios from "axios";

const PhotoComponent = ({ user }) => {
  const baseURL = config.API_BASE_URL;
  const defaultImageSrc = "/images/avatar.png";
  const [imageSrc, setImageSrc] = useState(defaultImageSrc);
  const [isRightDivVisible, setRightDivVisibility] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { isSmallScreen, handleBackClick } = useOutletContext();

  const imgUrl = config.PROFILE_IMAGES_URL;

  useEffect(() => {
    if (user?.profilePhoto) {
      setImageSrc(
        `${imgUrl}/${user.profilePhoto}`
      );
    } else {
      setImageSrc(defaultImageSrc);
    }
  }, [user?.profilePhoto]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleSaveAndContinue = async () => {
    window.scrollTo(0, 0);

    try {
      const formData = new FormData();
      formData.append("photo", document.getElementById("fileInput").files[0]);
      formData.append("userId", user.id);

      const response = await axios.post(
        `${baseURL}/v1/worker-users/images`,
        formData
      );

      const filenameMatch = response.data.match(/Successfully uploaded - (.+)/);

      if (filenameMatch && filenameMatch[1]) {
        const filename = filenameMatch[1];
        const fullPhotoURL = `${baseURL}/v1/profile-images/${filename}`;
        console.log("photo url", fullPhotoURL);
        console.log("Full response:", response);

        const updateUserResponse = await axios.patch(
          `${baseURL}/v1/worker-users/${user.id}`,
          {
            profilePhoto: filename,
          }
        );

        if (updateUserResponse.data) {
          console.log("patch successful");
          setShowModal(true);
        } else {
        }
      }
    } catch (error) {
      console.error(
        "Failed to upload photo and update profile:",
        error.message
      );
    }
  };

  return (
    <div className="photo-custom-component-container">
      {showModal && <SuccessModal />}
      <div className="photo-indicative-left-div">
        <div className="profile-back-container">
          {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon" />
            </div>
          )}
          <h2>Profile photo</h2>
        </div>

        <p>
          Your profile photo is crucial for creating a professional image,
          adding personality, and allowing clients to recognize you for safety
          reasons during your first support session.
        </p>

        <div className="photo-indicative-right-div">
          <h3>Photo guidelines</h3>
          <ul className="guideline-list">
            <li className="guideline-item guideline-required">
              <FaCheck className="guideline-icon guideline-icon-success" />
              Pick a headshot that represents you as a professional.
            </li>
            <li className="guideline-item guideline-required">
              <FaCheck className="guideline-icon guideline-icon-success" />
              Take the photo in soft, natural light.
            </li>
            <li className="guideline-item guideline-required">
              <FaCheck className="guideline-icon guideline-icon-success" />
              Be the only person in the photo.
            </li>
            <li className="guideline-item guideline-required">
              <FaCheck className="guideline-icon guideline-icon-success" />
              Smiling helps you look kind, friendly, and approachable.
            </li>
            <li className="guideline-item guideline-not-required">
              <FaTimes className="guideline-icon guideline-icon-fail" />
              Don’t use a low-resolution image.
            </li>
            <li className="guideline-item guideline-not-required">
              <FaTimes className="guideline-icon guideline-icon-fail" />
              Don’t use black and white photos and add filters.
            </li>
            <li className="guideline-item guideline-not-required">
              <FaTimes className="guideline-icon guideline-icon-fail" />
              Make sure no sunglasses, hat, or hair covers your face.
            </li>
            <li className="guideline-item guideline-not-required">
              <FaTimes className="guideline-icon guideline-icon-fail" />
              Don’t include objects, pets, children, or clients.
            </li>
          </ul>

        </div>
        <div className="photo-holder">
          <img
            src={imageSrc}
            alt="Profile Preview"
            onClick={handleButtonClick}
          />
        </div>

        <div className="photo-update-section">
          <button onClick={handleButtonClick}>Select new profile photo</button>
          <input
            type="file"
            id="fileInput"
            style={{ display: "none" }}
            onChange={handleFileChange}
            accept="image/*"
          />
          <label className="size-limit-label">Size limit: 5MB max</label>
        </div>
      </div>
      <div className="photo-save">
        <button onClick={handleSaveAndContinue}>Submit for Review</button>
      </div>
    </div>
  );
};

export default PhotoComponent;
